import { render } from "./TrainingListView.vue?vue&type=template&id=684abbd4&scoped=true"
import script from "./TrainingListView.vue?vue&type=script&lang=js"
export * from "./TrainingListView.vue?vue&type=script&lang=js"

import "./TrainingListView.vue?vue&type=style&index=0&id=684abbd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684abbd4"]])

export default __exports__